import React, { useState } from "react";
import { Row, Col, Input, Button, Modal, Select, Upload, Tag } from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import UITable from "../../Reusablecomponents/UITable/UITable";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

const PageWrapper = styled.div`
  padding: 20px;
`;

const TopSection = styled(Row)`
  margin-bottom: 20px;
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 16px;
  }
`;

const FilterButton = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #eef7ef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

const Badge = styled.div`
  position: absolute;
  top: -5px;
  right: -2px;
  background: red;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalTitle = styled.div`
  font-size: 32px;
  font-weight: 600;
  color: #5f6d8c;
`;

const UploadBox = styled.div`
  width: 100%;
  background: #e8f7e8;
  border-radius: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 20px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const InsurancePage = ({ activeTab }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const tableData = [
    {
      key: 1,
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      insurance: "Jubilee Insurance",
      insuranceType: "Comprehensive",
      daysRemaining: -10,
      expiryDate: "20 Feb 2025",
      status: "Expiring Soon",
    },
    {
      key: 2,
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      insurance: "Jubilee Insurance",
      insuranceType: "Comprehensive",
      daysRemaining: 88,
      expiryDate: "20 Feb 2025",
      status: "Valid",
    },
    {
      key: 3,
      vehicleNo: "KA1234532",
      driver: "John Doe",
      vehicleType: "Truck",
      insurance: "Jubilee Insurance",
      insuranceType: "Comprehensive",
      daysRemaining: -12,
      expiryDate: "20 Feb 2025",
      status: "Expired",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Valid":
        return "green";
      case "Expired":
        return "red";
      default:
        return "orange";
    }
  };

  const columns = [
    {
      title: "Vehicle No",
      dataIndex: "vehicleNo",
    },
    {
      title: "Driver",
      dataIndex: "driver",
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
    },
    {
      title: "Insurance",
      dataIndex: "insurance",
    },
    {
      title: "Insurance Type",
      dataIndex: "insuranceType",
    },
    {
      title: "Days Remaining",
      dataIndex: "daysRemaining",
      render: (value) => (
        <span
          style={{
            color: value > 0 ? "#1FAF38" : value < -10 ? "red" : "#E39A00",
            fontWeight: 500,
          }}
        >
          {value}
        </span>
      ),
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
    },
    {
      title: "Action",
      render: () => (
        <Button
          type="primary"
          style={{
            borderRadius: "20px",
            background: "#2EA043",
            width: "140px",
          }}
          onClick={() => setOpen(true)}
        >
          Renew
        </Button>
      ),
    },
  ];

  return (
    <>
      {activeTab === "insurance" ? (
        <PageWrapper>
          {/* <TopSection justify="space-between" align="middle">
            <Col xs={24} md={12}>
              <h2 style={{ color: "#5f6d8c" }}>229 Vehicles</h2>
            </Col>

            <Col xs={24} md={12}>
              <SearchWrapper>
                <Input
                  size="large"
                  placeholder="Search"
                  prefix={<SearchOutlined />}
                  style={{
                    borderRadius: "30px",
                    height: "45px",
                  }}
                />

                <FilterButton>
                  <FilterOutlined style={{ color: "#5f6d8c" }} />
                  <Badge>3</Badge>
                </FilterButton>
              </SearchWrapper>
            </Col>
          </TopSection> */}

          <UITable
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{ x: 1200 }}
            onRow={(record) => ({
              onClick: () => {
                console.log(record);

                navigate("/InsuranceDashboard", {
                  state: record,
                });
              },
            })}
          />

          <Modal
            open={open}
            footer={null}
            onCancel={() => setOpen(false)}
            centered
            width={700}
          >
            <ModalTitle>KA123</ModalTitle>

            <Row gutter={[20, 20]} style={{ marginTop: 30 }}>
              <Col xs={24} md={12}>
                <label>Insurance Provider</label>

                <Select
                  size="large"
                  defaultValue="Jubilee"
                  style={{
                    width: "100%",
                    marginTop: 8,
                  }}
                >
                  <Option value="Jubilee">Jubilee</Option>
                  <Option value="ICICI">ICICI</Option>
                </Select>
              </Col>

              <Col xs={24} md={12}>
                <label>Insurance Type</label>

                <Select
                  size="large"
                  defaultValue="Comprehensive"
                  style={{
                    width: "100%",
                    marginTop: 8,
                  }}
                >
                  <Option value="Comprehensive">Comprehensive</Option>
                  <Option value="Third Party">Third Party</Option>
                </Select>
              </Col>

              <Col xs={24} md={12}>
                <label>Expiry Date</label>

                <Select
                  size="large"
                  defaultValue="20/05/2020"
                  style={{
                    width: "100%",
                    marginTop: 8,
                  }}
                >
                  <Option value="20/05/2020">20/05/2020</Option>
                </Select>
              </Col>

              <Col span={24}>
                <Upload style={{ width: "100%" }}>
                  <UploadBox>
                    <Button
                      type="text"
                      icon={<UploadOutlined />}
                      style={{
                        color: "#2EA043",
                        fontSize: 24,
                      }}
                    >
                      Upload
                    </Button>
                  </UploadBox>
                </Upload>
              </Col>
            </Row>

            <FooterButtons>
              <Button
                size="large"
                style={{
                  borderRadius: "30px",
                  minWidth: "140px",
                }}
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                size="large"
                style={{
                  borderRadius: "30px",
                  minWidth: "140px",
                  background: "#2EA043",
                }}
              >
                Update
              </Button>
            </FooterButtons>
          </Modal>
        </PageWrapper>
      ) : null}
    </>
  );
};

export default InsurancePage;
